import { RoleEnum } from '../enums/role';

/**
 * Function check role isStaff
 * @param role
 * @returns
 */
function isStaff(role?: RoleEnum) {
  if (!role) return false;

  const listStaff = [RoleEnum.DigitalLeader, RoleEnum.SaleLead, RoleEnum.SaleStaff, RoleEnum.DigitalStaff];

  const isStaff = Object.values(listStaff)
    .filter(v => !isNaN(Number(v)))
    .some(x => +x === role);

  return isStaff;
}

function isProjectManager(role?: RoleEnum) {
  if (!role) return false;

  const listStaff = [RoleEnum.ProjectManager];

  const isStaff = Object.values(listStaff)
    .filter(v => !isNaN(Number(v)))
    .some(x => +x === role);

  return isStaff;
}
function isSale(role?: RoleEnum) {
  if (!role) return false;

  const listStaff = [RoleEnum.SaleLead, RoleEnum.SaleStaff];

  const isStaff = Object.values(listStaff)
    .filter(v => !isNaN(Number(v)))
    .some(x => +x === role);

  return isStaff;
}
function isDigital(role?: RoleEnum) {
  if (!role) return false;

  const listStaff = [RoleEnum.DigitalLeader, RoleEnum.DigitalStaff];

  const isStaff = Object.values(listStaff)
    .filter(v => !isNaN(Number(v)))
    .some(x => +x === role);

  return isStaff;
}
function isManagerAndSub(role?: RoleEnum) {
  if (!role) return false;

  const listStaff = [
    RoleEnum.ProjectManager,
    RoleEnum.ProjectSub,
    RoleEnum.SaleManager,
    RoleEnum.SaleSub,
    RoleEnum.DigitalSupervisor,
    RoleEnum.DigitalStaff,
    RoleEnum.DigitalLeader
  ];

  const isStaff = Object.values(listStaff)
    .filter(v => !isNaN(Number(v)))
    .some(x => +x === role);

  return isStaff;
}

function isAdmin(role?: RoleEnum) {
  if (!role) return false;

  const listStaff = [RoleEnum.Admin, RoleEnum.BOD, RoleEnum.CEO, RoleEnum.QC];

  const isStaff = Object.values(listStaff)
    .filter(v => !isNaN(Number(v)))
    .some(x => +x === role);

  return isStaff;
}

function isSaleTrucPageAndTelesale(role?: RoleEnum) {
  if (!role) return false;

  const listRole = [RoleEnum.SaleTrucPage, RoleEnum.Telesale];

  const isStaff = Object.values(listRole)
    .filter(v => !isNaN(Number(v)))
    .some(x => +x === role);

  return isStaff;
}

function isWithoutStaff(role?: RoleEnum) {
  if (!role) return false;

  const listWithoutStaff = [RoleEnum.SaleStaff, RoleEnum.DigitalStaff];

  const isStaff = Object.values(listWithoutStaff)
    .filter(v => !isNaN(Number(v)))
    .some(x => +x !== role);

  return isStaff;
}

export {
  isStaff,
  isManagerAndSub,
  isAdmin,
  isSaleTrucPageAndTelesale,
  isWithoutStaff,
  isSale,
  isDigital,
  isProjectManager
};
